<template>
  <form action="" v-on:submit.prevent="onSearch()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">絞り込み条件</p>
      </header>
      <section class="modal-card-body">
        <b-field label="共有書店コード">
          <b-input
              type="text"
              v-model="formProps.shop_code_cont"
              placeholder="000000"
              id="shop-code-input"
          >
          </b-input>
        </b-field>

        <b-field label="書店名">
          <b-input
              type="text"
              v-model="formProps.name_cont"
              placeholder="書店名"
              id="name-input"
          >
          </b-input>
        </b-field>
        <b-field label="取次コード">
          <b-input
              type="text"
              v-model="formProps.final_book_shop_agencies_agency_code_cont"
              placeholder="000"
              id="agency-code-input"
          >
          </b-input>
        </b-field>
        <b-field label="取次書店コード">
          <b-input
              type="text"
              v-model="formProps.final_book_shop_agencies_agency_shop_code_cont"
              placeholder="00000"
              id="agency-shop-code-input"
          >
          </b-input>
        </b-field>
        <b-field label="番線">
          <b-input
              type="text"
              v-model="formProps.final_book_shop_agencies_book_sorting_work_code_cont"
              id="book-sorting-work-code-input"
          >
          </b-input>
        </b-field>
        <b-field label="電話番号">
          <b-input
              type="text"
              v-model="formProps.telephone_cont"
              password-reveal
              placeholder="0312345678"
              id="telephone-input"
          >
          </b-input>
        </b-field>
        <b-field label="都道府県">
          <b-input
              type="text"
              v-model="formProps.prefecture_code_or_prefecture_name_cont"
              placeholder="都道府県"
              id="prefecture-input"
          >
          </b-input>
        </b-field>

      </section>
      <footer class="modal-card-foot">
        <button class="button is-info is-fullwidth"><i class="fas fa-undefine fa-search icon-left">この条件でさがす</i></button>
        <button class="button" type="button" @click="$parent.close()">
          <i class="fas fa-times"></i>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>

  export default {
    data() {
      return {
        final_book_shop_groups: []
      }
    },
    props: [ 'formProps' ],
    methods: {
      loadAsyncData() {
        this.$http.get(`/api/v1/final_book_shop_groups`)
            .then(({data}) => {
              this.final_book_shop_groups = []

              data.results.forEach((item) => {
                this.final_book_shop_groups.push(item)
              })
            })
            .catch((error) => {
              this.final_book_shop_groups = []
              throw error
            })
      },
      onSearch(){
        this.$emit('update:formProps', this.formProps)
        this.$emit('on-search')
        this.$parent.close()
      }
    },
    created() {
      this.loadAsyncData()
    }
  }

</script>